import { FC } from "react";
import { Container, Navigation, Section } from "../../../@component/layout";
import { Button } from "../../../@component/buttons";
import { Banner } from "../../../@component/sections/banner";
import { About } from "../../../@component/sections/about";
import { Program } from "../../../@component/sections/program";
import { Impact } from "../../../@component/sections/impact";
import { Location } from "../../../@component/sections/locations";
import { ContactUs } from "../../../@component/sections/contact-us";
import { Faqs } from "../../../@component/sections/faq";
import { Footer } from "../../../@component/layout/footer";

export const Contact: FC = (props) => {
  return (
    <Section>
      <Navigation>
        <Button>hallo</Button>
      </Navigation>
      <ContactUs />
      <Footer />
    </Section>
  );
};
